import InterpretationInterface from './interpretation-interface';
import DraftkingsInterpretation from './draftkings-interpretation';
import FanduelInterpretation from './fanduel-interpretation';
import YahooInterpretation from './yahoo-interpretation';
import CsvPlayerInterpretationNotFoundError from './csv-player-interpretation-not-found-error';

const interpretationMap = {
    draftkings: DraftkingsInterpretation,
    fanduel: FanduelInterpretation,
    yahoo: YahooInterpretation,
};

const CsvPlayerCellInterpretationFactory = {
    getInterpretation(sportConfig): InterpretationInterface {
        const site = sportConfig.getSite().toLowerCase();

        try {
            return new interpretationMap[site]();
        } catch (e) {
            if (e instanceof TypeError) {
                throw new CsvPlayerInterpretationNotFoundError('Csv Player Interpretation is undefined');
            }
            throw e;
        }
    },
};

export default CsvPlayerCellInterpretationFactory;
